export enum Key {
    Enter = 'Enter',
    Control = 'Control',
    Shift = 'Shift',
    Alt = 'Alt',
    A = 'A',
    a = 'a',
    l = 'l',
    k = 'k',
    d = 'd',
    c = 'c',
    v = 'v',
    x = 'x',
}


// WEBPACK FOOTER //
// ./src/webportal/utils/Key.ts